<div class="seeds-tab">
  <div class="seeds-header display-flex gap-12">
    <button type="button" class="primary-btn" (click)="openAdd()">{{ 'cardsAdminAdd' | transloco }}</button>
  </div>
  <p class="regular-14 color-soft-grey margin-top-12">{{ 'cardsAdminSeedHint' | transloco }}</p>

  @if (seeds.isLoading()) {
    <p class="regular-14">{{ 'loading' | transloco }}</p>
  } @else if (!seeds.value().length) {
    <p class="regular-14">{{ 'noResultsFound' | transloco }}</p>
  } @else {
    <div class="display-flex vertical gap-12 margin-top-16">
      @for (seed of seeds.value(); track seed.id) {
        <div class="seed-row display-flex gap-12" [class.used]="seed.status === 'used'">
          <div class="seed-names">
            <div class="semibold-14">{{ seed.name.en }}</div>
            <div class="regular-14 color-soft-grey">{{ seed.name.uk }}</div>
          </div>
          <span class="regular-14 quote-cell" [title]="seed.quote.en">{{ seed.quote.en }}</span>
          @if (seed.rarityHint) {
            <span
              class="rarity-chip semibold-14"
              [class.legendary]="seed.rarityHint === 'legendary'"
              [class.rare]="seed.rarityHint === 'rare'"
              [class.common]="seed.rarityHint === 'common'">{{ seed.rarityHint }}</span>
          } @else {
            <span class="regular-14 color-soft-grey">&mdash;</span>
          }
          <span class="regular-14 status-cell" [class.color-soft-grey]="seed.status === 'used'">
            {{ seed.status }}
            @if (seed.usedAt) {
              &middot; {{ seed.usedAt | date }}
            }
          </span>
          @if (seed.status === 'pending') {
            <button type="button" class="warning-bar-btn" (click)="deleteSeed(seed.id)">{{ 'delete' | transloco }}</button>
          }
        </div>
      }
    </div>
  }

  @if (showAddModal()) {
    <app-modal
      [title]="'cardsAdminAdd' | transloco"
      [footerButtons]="addModalButtons"
      (closeEvent)="closeAdd()">
      <input type="text" class="text-input" [formControl]="nameEnControl" [placeholder]="'cardsAdminNameEn' | transloco" />
      <input type="text" class="text-input margin-top-12" [formControl]="nameUkControl" [placeholder]="'cardsAdminNameUk' | transloco" />
      <input type="text" class="text-input margin-top-12" [formControl]="quoteEnControl" [placeholder]="'cardsAdminQuoteEn' | transloco" />
      <input type="text" class="text-input margin-top-12" [formControl]="quoteUkControl" [placeholder]="'cardsAdminQuoteUk' | transloco" />
      <select class="select-input margin-top-12" [formControl]="rarityHintControl">
        <option value="">none</option>
        <option value="common">common</option>
        <option value="rare">rare</option>
        <option value="legendary">legendary</option>
      </select>
      <input type="text" class="text-input margin-top-12" [formControl]="themeHintControl" placeholder="Theme hint (optional)" />
    </app-modal>
  }
</div>
